import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import {
  Button,
  Modal,
  Input,
  InputGroup,
  Form,
  FormGroup
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormFeedback } from '../Forms';
import { hasError } from '../../utils/Helpers';
import eyeOpen from '../../images/eye-open.png';
import eyeClose from '../../images/eye-close.png';
// import Loading from '../../components/Loading';

/*
type Props = {
  isOpen: Boolean,
  onToggle: Function,
  titleModal: string,
  hasPassword: Boolean,
  onClick: Function,
  value: string, 
  onTextChange: Function,
  error: ?Object
}
*/

class ModalPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visiblePassword: false
    }

    this.toggleVisible = this.toggleVisible.bind(this);
  }

  toggleVisible() {
    this.setState({
      visiblePassword: !this.state.visiblePassword
    })
  }

  toggle = () => {
    const { onToggle, isSubmit } = this.props;
    if (onToggle && !isSubmit) {
      onToggle();
    }
  }

  render() {
    const { visiblePassword } = this.state;
    return (
      <Modal
        modalClassName="modal-password"
        isOpen={this.props.isOpen}
        toggle={this.toggle}
      >
        <div className="password-header">
          <p>{this.props.titleModal}</p>
        </div>
        <div className="password-content">
          {
            this.props.hasPassword === false ?
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <p>You do not have inserted any password yet. Please click link below to create your password:</p>
                <a href="/forgot-password" target="_blank" className="text-black d-block" style={{ color: '#4990e2' }}><span>Forgot Password</span></a>
              </div>
              :
              <div>
                <div className="text-desc">
                  <p>Please enter your password to continue</p>
                </div>

                <Form onSubmit={this.props.onClick}>
                  <FormGroup className="password-input">
                    <InputGroup>
                      <Input type={visiblePassword ? "text" : "password"} value={this.props.value} onChange={this.props.onTextChange} />
                      <KickImage className="img-eye" src={visiblePassword ? eyeOpen : eyeClose} onClick={this.toggleVisible} alt="visible-password" />
                    </InputGroup>
                    <p className="invalid-password">{this.props.error}</p>
                  </FormGroup>
                  <div className="password-button">
                    {
                      <Button
                        disabled={this.props.isSubmit || this.props.value === ""}
                        className={"password-content"}
                        style={{ backgroundColor: this.props.isSubmit || this.props.value === "" ? '#4a4a4a' : '#159953' }}
                      >
                        {this.props.isSubmit ? 'Loading...' : 'Submit'}
                      </Button>
                    }
                  </div>
                </Form>
              </div>
          }
        </div>
      </Modal>
    )
  }
}

export default ModalPassword;

ModalPassword.defaultProps = {
  isOpen: false,
  isSubmit: false
}
